// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3IbMK","footer":"ModalUpdate_footer__CtOaP"};